"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var style_1 = require("./style");
var ArrowUp_1 = __importDefault(require("./ArrowUp"));
var BackToTopButton = function (_a) {
    var caption = _a.caption, className = _a.className, onClick = _a.onClick;
    return (react_1.default.createElement(style_1.Wrapper, { caption: caption, className: className, onClick: onClick },
        react_1.default.createElement("div", { className: 'BackToTopButton__roundButton' },
            react_1.default.createElement(ArrowUp_1.default, null)),
        caption !== undefined
            ? (react_1.default.createElement("div", { className: 'BackToTopButton__caption' }, caption))
            : null));
};
exports.default = BackToTopButton;
__exportStar(require("./types"), exports);
